import type { ConfigurationContextValue } from "./ConfigurationContext";

// Brand Kit FaroMarket V3 — logos oficiais (paths/outline, sem dependência de fonte)
// Origem canônica: D:\FaroMarket\12_Documentacao\Logomarca\FaroMarket_V3\
// Os SVGs em public/logos/faromarket-logo-symbol*.svg são idênticos byte-a-byte
// aos arquivos `svg/editable/icon/faromarket-icon{,-dark}.svg` do brand kit.
//
// Variação escolhida — SYMBOL (ícone quadrado 64x64), não Horizontal:
// O Header renderiza <img className="h-6" /> ao lado de <h1>{title}</h1>.
// A logo horizontal (340x80) renderizada a 24px de altura vira uma faixa
// estreita onde a palavra "FaroMarket" desenhada dentro fica ilegível, e
// fica redundante com o <h1>"CRM FaroMarket"</h1>. O ícone quadrado fica
// nítido em 24px e complementa o título sem redundância — alinhado ao
// Brand Guide V3 (tamanho mínimo de ícone: 24px UI).
//
// - Light mode (`darkModeLogo` aparece em fundo escuro): ícone com
//   FUNDO BRANCO + letras navy + barra cyan.
// - Dark mode  (`lightModeLogo` aparece em fundo claro):  ícone com
//   FUNDO NAVY  + letras brancas + barra cyan.
export const defaultDarkModeLogo = "./logos/faromarket-logo-symbol-dark.svg";
export const defaultLightModeLogo = "./logos/faromarket-logo-symbol.svg";

// Versão do Brand Kit. Quando muda, o seed em CRM.tsx força re-aplicação dos
// logos na config persistida em localStorage (preservando outras customizações).
// v4 (2026-05-18): default trocado de logo `horizontal` para `symbol` para
// resolver redundância visual e ilegibilidade no Header (24px).
export const BRAND_KIT_VERSION = "v4";

export const defaultCurrency = "BRL";

export const defaultTitle = "CRM FaroMarket";

// Locale para formatação financeira. FaroMarket atende PMEs brasileiras —
// mesmo quando currency não é BRL, exibimos no padrão pt-BR (R$ 1.234,56 / US$ 1.234,56).
export const defaultLocale = "pt-BR";

// Setores aderentes ao público FaroMarket (PMEs brasileiras), em vez da
// taxonomia GICS upstream (orientada para mercado de capitais).
export const defaultCompanySectors = [
  { value: "varejo_fisico", label: "Varejo físico" },
  { value: "ecommerce", label: "E-commerce" },
  { value: "servicos_locais", label: "Serviços locais" },
  { value: "alimentacao_bebidas", label: "Alimentação e bebidas" },
  { value: "saude_estetica", label: "Saúde e estética" },
  { value: "educacao_cursos", label: "Educação e cursos" },
  { value: "servicos_b2b", label: "Serviços B2B" },
  { value: "industria_pequeno_porte", label: "Indústria de pequeno porte" },
  { value: "construcao_reformas", label: "Construção e reformas" },
  { value: "tecnologia_software", label: "Tecnologia e software" },
  { value: "outro", label: "Outro" },
];

// @deprecated — etapas de funil NÃO são mais lidas daqui. Fonte de verdade
// é public.pipeline_stages (vinculado a public.pipelines). Mantido apenas
// como fallback técnico para componentes legados que ainda referenciam
// `useConfigurationContext().dealStages` durante a transição (Fase A).
// Será removido na Fase B quando todos os consumidores migrarem para
// useGetList("pipeline_stages").
export const defaultDealStages = [
  { value: "novo_contato", label: "Novo contato" },
  { value: "qualificacao", label: "Qualificação" },
  { value: "proposta_enviada", label: "Proposta enviada" },
  { value: "negociacao", label: "Negociação" },
  { value: "ganho", label: "Ganho" },
  { value: "perdido", label: "Perdido" },
];

// @deprecated — antigo "status do funil" (terminalidade ganho/perdido) agora
// vem de pipeline_stages.is_won / pipeline_stages.is_lost.
export const defaultDealPipelineStatuses = ["ganho"];

export const defaultDealCategories = [
  { value: "inteligencia_mercado", label: "Inteligência de mercado" },
  { value: "expansao_localizacao", label: "Expansão e localização" },
  { value: "diagnostico_estrategico", label: "Diagnóstico estratégico" },
  { value: "analise_comercial", label: "Análise comercial e oportunidades" },
  { value: "outro", label: "Outro" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frio", color: "#7dbde8" },
  { value: "warm", label: "Morno", color: "#e8cb7d" },
  { value: "hot", label: "Quente", color: "#e88b7d" },
  { value: "in_contract", label: "Em contrato", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "sem_tipo", label: "Sem tipo" },
  { value: "email", label: "E-mail" },
  { value: "demonstracao", label: "Demonstração" },
  { value: "reuniao_informal", label: "Reunião informal" },
  { value: "reuniao", label: "Reunião" },
  { value: "retorno", label: "Retorno" },
  { value: "agradecimento", label: "Agradecimento" },
  { value: "envio_material", label: "Envio de material" },
  { value: "ligacao", label: "Ligação" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
  _brandKitVersion: BRAND_KIT_VERSION,
};
